import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  Application,
  ListRequestOfAdminApplicationFilter,
  ListResponseOfApplication,
} from "services/KnowfullyAdminClient";

interface SelectApplicationProps
  extends Omit<
    AutocompleteWithQueryProps<Application>,
    "fetchedData" | "failMessage" | "labelField"
  > {
  allowGrantingUserAccess?: boolean;
  excludeApplicationIds?: string[];
  organizationId?: string;
}

const SelectApplication = ({
  allowGrantingUserAccess,
  excludeApplicationIds,
  organizationId,
  ...props
}: SelectApplicationProps) => {
  const { formatMessage: t } = useIntl();
  const { applicationService } = useGlobalContext();

  const fetchedData = useQuery<ListResponseOfApplication>(
    [
      "applicationService.getAdminApplications",
      allowGrantingUserAccess,
      excludeApplicationIds,
      organizationId,
    ],
    () =>
      applicationService.getAdminApplications(
        ListRequestOfAdminApplicationFilter.fromJS({
          sortField: "name",
          parameters: {
            allowGrantingUserAccess,
            excludedIds: excludeApplicationIds,
            organizationId,
          },
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "selectApplicationFetchFailed" })}
    />
  );
};

export default SelectApplication;
